"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIdentifiers = getIdentifiers;
const getFormula_js_1 = require("./getFormula.js");
const getInChI_js_1 = require("./getInChI.js");
const getInChIKey_js_1 = require("./getInChIKey.js");
const getSMILES_js_1 = require("./getSMILES.js");
function getIdentifiers(data) {
    return {
        formula: (0, getFormula_js_1.getFormula)(data),
        inchi: (0, getInChI_js_1.getInChI)(data),
        inchiKey: (0, getInChIKey_js_1.getInChIKey)(data),
        smiles: (0, getSMILES_js_1.getSMILES)(data),
    };
}
//# sourceMappingURL=getIdentifiers.js.map